import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { MatCheckboxModule } from '@angular/material/checkbox';

/**
 * The POPIA s72 consent to AI-assisted assessment — ONE wording, everywhere it
 * is asked.
 *
 * Since 2026-09-22 this is a sign-up question: asked once on the register form
 * (and on the two invitation-accept forms, which are a sign-up for the
 * invitee), recorded against the account, and standing for every application
 * that person makes. The application screens render this same box only as the
 * fallback — when no standing consent exists (an account from before the
 * capture, or a withdrawn one) or when the consent on that one record was
 * withdrawn — so the question is put again rather than assumed.
 *
 * The text below IS the consent (`AI_CONSENT_TEXT_VERSION` on the backend
 * stamps each row with the version of it the person agreed to). Change it here
 * and bump that constant in the same change; do not paraphrase it on a screen.
 * Varies Legal's DOC-76 `UI-DA-76-01` on Gerrit's instruction of 2026-11-02: it names no
 * provider. Staged for Legal (open-asks §2).
 *
 * Style guide: consent names what is consented to — never a blanket "I agree".
 */
@Component({
  selector: 'app-ai-consent-checkbox',
  imports: [MatCheckboxModule, RouterLink],
  templateUrl: './ai-consent-checkbox.html',
  styleUrl: './ai-consent-checkbox.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AiConsentCheckboxComponent {
  /** Fills Legal's [business name]. Sign-up has no business yet: 'the business'. */
  readonly businessName = input('');
  readonly checked = input(false);
  readonly disabled = input(false);
  /** The `data-testid` on the box, so each host keeps its own hook. */
  readonly testId = input('ai-consent-checkbox');
  readonly changed = output<boolean>();
}
